import { get } from "lodash";
import { ApplicationStep3 } from "../ApplicationStep3.class";
import { Owner } from "../../polymer/Owner.model";
import { LoanTypeEnum } from "../../enum/loan-type.enum";
import { FileItem } from "../../polymer/Document.model";

export class StageBReviewEndorse{
  //DONE VALIDATION
  public input_verified: boolean; //USED
  
  constructor(initial?:any){
   
    //USED
    this.input_verified = get(initial, 'input_verified', false);
  }

}


export class StageBFinancial{
  public loan_type : LoanTypeEnum | undefined;
  public loan_amount : string;
  constructor(initial?:any){
    this.loan_type = get(initial, 'loan_type', undefined);
    this.loan_amount = get(initial, 'loan_amount', '');
  }
}


export class StageBConveyancing extends ApplicationStep3{
  // // public represented_different_solicitor  : boolean; //USED
  
  constructor(initial?:any){
    super(initial);
  }   
}


export class StageBPersonalDetail {
  public login_user: Owner;
  constructor(initial?: any) {
    this.login_user = get(initial, 'login_user', new Owner(initial));
  }
}
export class StageBDocumentation {
  public file_items: FileItem[];

  constructor(initial?: any) {
    this.file_items = get(initial, 'file_items', []);
  }
}